angular.module('myApp.controllers')
    .controller('MainCtrl', function($scope) {
    });